import I18n from 'I18n';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import { selectKnowledgeBase } from '../../knowledge-base/selectors/knowledgeBaseDetails';
import { useAppSelector } from '../../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ReadyOnlyInput() {
  const {
    domain,
    slug
  } = useAppSelector(selectKnowledgeBase);
  const url = `${domain}/${slug}`;
  function I18nText(messageKey) {
    return I18n.text(`knowledgeContentUI.templateEditor.fields.${messageKey}`);
  }
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: I18nText('knowledgeBaseNameURL.label'),
    tooltip: I18nText('knowledgeBaseNameURL.helpText'),
    children: /*#__PURE__*/_jsx(UITextInput, {
      readOnly: true,
      value: url || ''
    })
  });
}